import { render } from "./InventoryLedgerPanel.vue?vue&type=template&id=2d323597&scoped=true"
import script from "./InventoryLedgerPanel.vue?vue&type=script&lang=js"
export * from "./InventoryLedgerPanel.vue?vue&type=script&lang=js"

import "./InventoryLedgerPanel.vue?vue&type=style&index=0&id=2d323597&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d323597"]])

export default __exports__